<template>
  <div class="app">
    <img v-if="sUrl" :src="sUrl" class="preview-img" />
    <div class="share-wrap" ref="canvas" v-if="!sUrl">
<!--       <div class="header-img">
        <img :src="oDetails.cover" />
      </div> -->
      <h3 class="tt">A.O.史密斯<br />用户安装实例</h3>
      <div class="user-infos">
        <div class="headimg">
          <img
            src="https://pro-core.babycdn.com/2020/08aosmith/images2020/release_case/headimg.jpg"
          />
        </div>
        <div class="info">
          <h5>案例信息</h5>
          <div class="txt"><span>城市：{{oDetails.city_name}}</span><span>小区：{{oDetails.address}}</span></div>
          <div class="txt" v-if="oDetails.house_area">面积：{{ oDetails.house_area }}m²</div>
        </div>
      </div>
      <!-- 限时福利 -->
      <div class="coupon-section-wrap long" v-if="arrActivityList.length">
        <h3>限时福利</h3>
        <ul>
          <li v-for="item in arrActivityList" :key="item.activityId">
            <div class="ercode-wrap">
              <div class="ercode-box">
                <img :src="item.code.qrcode" />
              </div>
              <p>
                <span>扫码</span>
                <span>领取</span>
                <span>福利</span>
              </p>
            </div>
            <div class="active">
              <div class="img-box">
                <img :src="item.data.bannerUrl" />
              </div>
              <div class="detile-box">
                <h4>{{ item.data.activityName }}</h4>
                <div class="tips-box">
                  <p>已有{{ item.data.enter }}人报名参加</p>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <!-- 安装案例 -->
      <div class="case-list">
        <!-- <h3>安装案例</h3> -->
        <div class="case-item" v-if="oDetails.genre_img">
          <h5>口碑晒单</h5>
          <div class="image-wrap">
            <img
              v-lazy="oDetails.genre_image[0].img_url"
              alt="图片"/>
          </div>
        </div>

        <div
          class="case-item"
          v-for="item in oDetails.new_scenes"
          :key="item.id"
        >
          <h5>{{ item.scenes_name ? item.scenes_name + "场景" : "" }}</h5>
          <!-- <div class="xian"></div> -->
          <!-- <div class="kitchen" >
                      <div class="chenleft"><p>{{item.scenes_name}}</p></div>
                      <div class="chenright">
                        <div v-for="icons in item.icon" :key="icons.name" >
                          <img :src="icons.src" alt />
                          <span>{{icons.name}}</span>
                        </div>
                      </div>
                    </div> -->
          <div class="image-wrap">
            <img
              v-for="imgIt in item.house_img"
              :src="imgIt.img_url"
              :key="imgIt.img_id"
              alt="图片"
            />
          </div>
          <div class="goods-wrap" v-if="item.goods_info.length">
            <div class="titel">
              <span class="left"></span>
              案例中的商品
              <span class="right"></span>
            </div>
            <ul class="goods-list">
              <li v-for="git in item.goods_info" :key="git.id" v-if="git.id">
                <div class="img-box">
                  <img :src="git.mobile_thumb" />
                </div>
                <div class="title">
                  <div>{{ git.goods_type_name }}</div>
                  <div>{{ git.goods_name }}</div>
                  <div
                    class="selling"
                    v-for="(gitem, gindex) in git.attr"
                    :key="gindex"
                    v-if="gitem.attr_mean < 4 && gindex < 3"
                  >
                    <span>·</span>{{ gitem.attr_value }}
                  </div>
                </div>
                <!-- <div class="content">
                                  <p>{{git.goods_type_name}}{{git.goods_name}}</p>
                                  <ol>
                                     <li v-for="(ait,aindex) in git.attr" :key="aindex" v-show="aindex < 3">{{ait.attr_value}}</li>
                                  </ol>
                                </div> -->
              </li>
            </ul>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="seller-box">
        <div class="info" v-if="oCards.name || oCards.mobile || oCards.qrCode">
          <div class="user-info">
            <div class="avatar">
              <img :src="oCards.avatar" />
            </div>
            <h5>高级服务顾问</h5>
            <p>扫码联系 了解更多</p>
          </div>
          <div class="wrap-info">
            <div class="ercode-box">
              <div class="ercode">
                <img :src="oCards.qrCode" />
              </div>
              <div class="content">
                <ul>
                  <li>
                    <div class="lable">微信昵称</div>
                    <div id="nickname">{{ oCards.name }}</div>
                  </li>
                  <li class="phone">
                    <div class="lable">电话</div>
                    <div id="phone">{{ oCards.mobile }}</div>
                  </li>
                </ul>
                <p>一键保存名片/添加好友</p>
              </div>
            </div>
          </div>
        </div>
        <div class="logo">
          <img src="@/assets/images/system/logo2.png" />
        </div>
      </div>
    </div>
    <!-- 加载loading -->
    <el-propress :bShowPropress="bShowPropress" :nRate="nRate"></el-propress>
  </div>
</template>
<script>
import path from "@/path.js";
import html2canvas from "html2canvas";
import elPropress from "@/components/propress/index";
import md5 from "js-md5";
import CryptoJS from "crypto-js";
let OSS = require("ali-oss");
const imgPreloader = (url) => {
  return new Promise((resolve, reject) => {
    let image = new Image();
    image.src = url;
    image.onload = () => {
      resolve(image.src);
    };
    image.onerror = () => {
      reject("");
    };
  });
};
let progressTime = null;
export default {
  components: {
    elPropress,
  },
  data() {
    return {
      oDetails: {
        card: {},
      }, //案例详情
      arrActivityList: [], //活动列表
      sUrl: "",
      arrImage: [],
      bShowPropress: true, //进度条显示
      nRate: 0,
      oCards: {}, //企业微信
      count: 0,
    };
  },
  created() {},
  mounted() {
    this.getDetails();
  },
  methods: {
    async getDetails() {
      // this.$store.commit("loadBgSwitch", true);
      // this.$store.commit("loadSwitch", true);
      this.bShowPropress = true;
    //   this.addRate();
      let data = {
        topic_id: this.$route.query.topicid,
        user_id: this.$route.query.userid,
        activity_id: this.$route.query.sShareIds || "",
        source: "xcx",
      };
      for (let key in data) {
        if (data[key] == "") {
          delete data[key];
        }
      }
      let oDetails = await path.post5(path.gettopic, data);
      let oCards = await path.post5(path.getCards, {
        user_id: this.$route.query.userid,
      });
      this.oDetails = oDetails.data.data.result;
      this.oCards = oCards.data.data.result;
      // console.log("企业微信", this.oCards);
      this.arrActivityList = oDetails.data.data.result.activity;
      // 封面图
      if (this.oDetails.cover) {
        this.arrImage.push(this.oDetails.cover);
      }
      // 活动图
      this.arrActivityList.forEach((it) => {
        if (it.code.qrcode) {
          this.arrImage.push(it.code.qrcode);
        }
        if (it.data.bannerUrl) {
          this.arrImage.push(it.data.bannerUrl);
        }
      });
      // 场景
      this.oDetails.new_scenes.forEach((it) => {
        it.goods_info.forEach((git) => {
          if (git.mobile_thumb) {
            this.arrImage.push(git.mobile_thumb);
          }
        });
        it.house_img.forEach((git) => {
          if (git.img_url) {
            this.arrImage.push(git.img_url);
          }
        });
        it.icon.forEach((git) => {
          if (git.src) {
            this.arrImage.push(git.src);
          }
        });
      });

      //  console.log("预加载图片", this.arrImage);
      this.getImages(this.arrImage)
    //   .then((res) => {
    //     // alert('图片加载完成')
    //     console.log("加载完成", res);
    //     this.$nextTick(() => {
    //       setTimeout(() => {
    //         this.htmlToImage();
    //       }, 1500);
    //     });
    //   });
    },

    htmlToImage() {
      let sHeight = document.querySelector(".share-wrap").offsetHeight;
      let sWidth = document.querySelector(".share-wrap").offsetWidth;
      var scale = 2;
      // alert('开始画图')
      html2canvas(this.$refs.canvas, {
        useCORS: true,
        height: sHeight,
        width: sWidth,
        dpi: window.devicePixelRatio,
        scale: scale,
      })
        .then((canvas) => {
          let sUrl = canvas.toDataURL("image/png");
          this.getOssSts(sUrl);
        })
        .catch((fail) => {
          //  console.log(fail);
        });
    },
    // 图片预加载
    imgsPreloader(imgs) {
      let that = this;
    //   let promiseArr = [];
    //   imgs.forEach((it) => {
    //     promiseArr.push(it);
    //   });
      that.getImages(imgs);
      //   return Promise.all(promiseArr);
    },
    getImages(arrImage) {
      let that = this;
      // for (let img of arrImage) {
        // console.log('--->',arrImage)
      let image = new Image();
      image.src = arrImage[that.count];
      image.onload = () => {
          that.count++;
        // 计算图片加载的百分数，绑定到percent变量
        let percentNum = Math.floor((that.count / arrImage.length) * 100);
        // this.percent = `${percentNum}%`;
        that.nRate = percentNum;
        //  console.log(percentNum)
        if (that.count == arrImage.length) {
          that.$store.commit("loadSwitch", true);
          setTimeout(() => {
            this.htmlToImage();
          }, 1500);
        } else {
            that.getImages(arrImage);
        }
      };
      image.onerror = () => {
          this.$toast({
            message: '图片加载失败',
            duration: 500,
          });
          //  console.log('加载失败')
        // this.bShowBtn = true;
      };
      // }
    },
    addRate() {
      progressTime = setInterval(() => {
        let nNum = Math.floor(Math.random() * (10 - 1 + 1) + 1);
        this.nRate += nNum;
        if (this.nRate >= 99) {
          this.nRate = 99;
        }
      }, 1000);
    },
    async uploadImage(sUrl) {
      let data = {
        base64img: sUrl,
      };
      let oUploadImg = await path.post5(path.uploadFile, data);
    },
    // 获取oss配置
    async getOssSts(sUrl) {
      let oOssData = await path.post5(path.getOssSts, {
        ext: "png",
        user_id: this.$route.query.userid,
      });
      let oOss = oOssData.data.data.result;
      //  console.log("加密数据", oOss);
      let sKey = `tbzIwry9lT0qU81m${oOss.timestamp}`;
      // let oOssDecrypt = this.decrypt(sKey, oOss.body);
      let oFile = await this.base64ToLife(sUrl, oOss.key);
      this.ossUploadImg(oOss, oFile);
    },
    // base64 转 Blod
    base64ToLife(dataurl, filename) {
      return new Promise((resolve, reject) => {
        const arr = dataurl.split(",");
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        let blod = new Blob([u8arr], { type: mime });
        // blod.lastModifiedDate = new Date();
        // blod.name = filename;
        resolve(blod);
      });
    },
    // 解密
    decrypt(sKey, sBody) {
      return new Promise((resolve, reject) => {
        let sMd5Key = md5(sKey).substring(0, 16);
        //  console.log("Md5Key:", sMd5Key, "密文:", sBody);
        var key = CryptoJS.enc.Utf8.parse(sKey);
        var decrypt = CryptoJS.AES.decrypt(sBody, key, {
          mode: CryptoJS.mode.ECB,
          padding: CryptoJS.pad.Pkcs7,
        });
        //  console.log(decrypt);
        //  console.log(this.$crypto.enc.Utf8.stringify(decrypt));
      });
    },
    // 上传图片到oss
    async ossUploadImg(oOss, oFile) {

      let client = new OSS({
        region: oOss.sts.region,
        bucket: oOss.sts.bucket,

        accessKeyId: oOss.sts.access_key_id,
        accessKeySecret: oOss.sts.access_key_secret,
        endpoint: oOss.sts.endpoint_internal,
        stsToken: oOss.sts.security_token,
        //cname: true,
        // timeout:30,
        secure: true,
      });
      try {
        //  console.log(oOss.object_name, oFile);
        client
          .multipartUpload(oOss.object_name, oFile)
          .then((res) => {
            //  console.log(res);
            let sFileName = res.name;
            this.savePoster(oOss.filename); //保存海报
          })
          .catch((err) => {
            //  console.log("错误信息", err);
          });
      } catch (e) {
        //  console.log(e);
      }
    },
    async savePoster(sFileName) {
      let oData = {
        image_url: sFileName,
        user_id: this.$route.query.userid,
      };
      let oSavePoster = await path.post5(path.savePoster, oData);
      let nPosterId = oSavePoster.data.data.result;
      this.nRate = 100;
      clearInterval(progressTime);
      setTimeout(() => {
        wx.miniProgram.redirectTo({
          url: `/pages/case/poster/index?nId=${nPosterId}`,
        });
      }, 1000);
    },
  },

  destroyed() {
    clearInterval(progressTime);
  },
};
</script>
<style lang="scss" scoped>
@import "share.scss";
</style>
